var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopHalfEllipse = function SvgTopHalfEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M94.398 48c0-26.068-21.132-47.2-47.2-47.2C21.131.8-.002 21.932-.002 48z"
  })));
};
export { SvgTopHalfEllipse as ReactComponent };
export default __webpack_public_path__ + "images/top-half-ellipse.svg";